import XAxis from './XAxis';
import Axis from '../Axis';
const ChartXAxis = XAxis;
ChartXAxis.Title = Axis.Title;
export default ChartXAxis;